"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearMakeModelEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const YearMakeModelDto_1 = require("./YearMakeModelDto");
class YearMakeModelEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, yearMakeModel) {
        super();
        this._requiredFieldsSetStatus = {
            year: false,
            make: false,
            model: false,
            style: false,
            styleId: false,
            fullStyleCode: false,
            histStyleId: false,
            histModelId: false,
            autoBuilderStyleId: false
        };
        this._dependencies = dependencies;
        if (yearMakeModel === undefined) {
            this._dto = new YearMakeModelDto_1.YearMakeModelDto();
        }
        else if (yearMakeModel instanceof YearMakeModelDto_1.YearMakeModelDto) {
            this._dto = new YearMakeModelDto_1.YearMakeModelDto(yearMakeModel);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else if (yearMakeModel instanceof YearMakeModelEntity) {
            this._dto = new YearMakeModelDto_1.YearMakeModelDto(yearMakeModel._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(false);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new YearMakeModelDto_1.YearMakeModelDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getYear() {
        return this._dto.year;
    }
    setYear(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            _untrustedValue = untrustedValue;
        }
        else {
            _untrustedValue = parseInt(untrustedValue, 11);
        }
        if (_untrustedValue === this._dto.year) {
            return;
        }
        this.clearError("year");
        this._requiredFieldsSetStatus.year = true;
        if (_untrustedValue === undefined ||
            _untrustedValue === null ||
            !Number.isInteger(_untrustedValue) ||
            _untrustedValue <= 0) {
            this.addError(new ValidationError_1.ValidationError("year", "Year is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.year) {
            return;
        }
        this._dto.year = _untrustedValue;
        this._setIsDirty(true);
    }
    getMake() {
        return this._dto.make;
    }
    setMake(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.make) {
            return;
        }
        this.clearError("make");
        this._requiredFieldsSetStatus.make = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("make", "make Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("make", `Make Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.make) {
            return;
        }
        this._dto.make = _untrustedValue;
        this._setIsDirty(true);
    }
    getModel() {
        return this._dto.model;
    }
    setModel(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.model) {
            return;
        }
        this.clearError("model");
        this._requiredFieldsSetStatus.model = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("model", "Model is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("model", `Model has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.model) {
            return;
        }
        this._dto.model = _untrustedValue;
        this._setIsDirty(true);
    }
    getStyle() {
        return this._dto.style;
    }
    setStyle(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.style) {
            return;
        }
        this.clearError("style");
        this._requiredFieldsSetStatus.style = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("style", "Style is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("style", `Style has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.style) {
            return;
        }
        this._dto.style = _untrustedValue;
        this._setIsDirty(true);
    }
    getStyleId() {
        return this._dto.id;
    }
    setStyleId(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.styleId) {
            return;
        }
        this.clearError("styleId");
        this._requiredFieldsSetStatus.styleId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("styleId", "Full Style Code is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("styleId", `Full Style Code has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.styleId) {
            return;
        }
        this._dto.styleId = _untrustedValue;
        this._setIsDirty(true);
    }
    getFullStyleCode() {
        return this._dto.fullStyleCode;
    }
    setFullStyleCode(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.fullStyleCode) {
            return;
        }
        this.clearError("fullStyleCode");
        this._requiredFieldsSetStatus.fullStyleCode = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("fullStyleCode", "Full Style Code is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("fullStyleCode", `Full Style Code has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.fullStyleCode) {
            return;
        }
        this._dto.fullStyleCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getHistStyleId() {
        return this._dto.histStyleId;
    }
    setHistStyleId(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.histStyleId) {
            return;
        }
        this.clearError("histStyleId");
        this._requiredFieldsSetStatus.histStyleId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("histStyleId", "Hist Style Id is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("histStyleId", `Hist Style Id has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.histStyleId) {
            return;
        }
        this._dto.histStyleId = _untrustedValue;
        this._setIsDirty(true);
    }
    getHistModelId() {
        return this._dto.histModelId;
    }
    setHistModelId(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.histModelId) {
            return;
        }
        this.clearError("histModelId");
        this._requiredFieldsSetStatus.histModelId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("histModelId", "Hist Model Id is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("histModelId", `Hist Model Id has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.histModelId) {
            return;
        }
        this._dto.histModelId = _untrustedValue;
        this._setIsDirty(true);
    }
    getAutoBuilderStyleId() {
        return this._dto.autoBuilderStyleId;
    }
    setAutoBuilderStyleId(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        if (_untrustedValue === this._dto.autoBuilderStyleId) {
            return;
        }
        this.clearError("autoBuilderStyleId");
        this._requiredFieldsSetStatus.autoBuilderStyleId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("autoBuilderStyleId", "Hist Style Id is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("autoBuilderStyleId", `Hist Style Id has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.autoBuilderStyleId) {
            return;
        }
        this._dto.autoBuilderStyleId = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.yearMakeModelDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Year Make Model is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.yearMakeModelDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.yearMakeModelDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Year Make Model cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.yearMakeModelDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.YearMakeModelEntity = YearMakeModelEntity;
//# sourceMappingURL=YearMakeModelEntity.js.map